import { withClientErrorPage } from '@sm/webassets';
import FourOhFourError from './FourOhFourError';

export default withClientErrorPage(FourOhFourError, { titularElementTag: 'h1' });
